/**
 *
 * MyAccount
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import validateEmail from "utils/validateEmail"
import { Button, Divider, Input, Select } from "antd"
import { Form } from "@ant-design/compatible"
import { isEqual, pick } from "lodash"

import Loader from "components/Loader"
import Layout from "components/Layout"
import {
  makeSelectUser,
  makeSelectIsLoadingUser,
  makeSelectLanguage,
  makeSelectIsLoadingLanguage,
} from "./selectors"
import saga from "./saga"
import reducer from "./reducer"
import {
  getUserWatcher,
  getUserSuccess,
  putUserWatcher,
  passwordUserWatcher,
  getLanguageWatcher,
  putLanguageWatcher,
} from "./actions"
import "@ant-design/compatible/assets/index.css"
import "./index.less"
import { loadTexts } from "../../utils/i18n"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class MyAccount extends React.Component {
  intlMyAccount = loadTexts("my_account")
  state = {
    loadingPage: true,
    new_password: undefined,
    password: undefined,
    new_password_confirmation: undefined,
    actual_language: undefined,
  }

  constructor(props) {
    super(props)
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this)
  }

  componentDidMount = () => {
    this.props.getUserWatcher()
    this.props.getLanguageWatcher()

    setTimeout(() => {
      this.setState({ loadingPage: false })
    }, 1500)
  }

  componentDidUpdate = (prevProps) => {
    if (
      !isEqual(prevProps.isLoadingUser, this.props.isLoadingUser) &&
      !this.props.isLoadingUser
    ) {
      this.setState({ ...this.props.user })
      this.setState({ actual_language: this.props.user.language })
    }
  }

  componentWillUnmount = () => {
    this.props.getUserSuccess({})
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  sendInfoSave = () => {
    const data = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      second_last_name: this.state.second_last_name,
      email: this.state.email,
    }

    this.props.putUserWatcher(data)
  }

  validateButtonSave = () => {
    if (this.props.isLoadingUser) return

    const valueState = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      second_last_name: this.state.second_last_name,
      email: this.state.email,
    }

    const valueProps = {
      ...pick(this.props.user, [
        "first_name",
        "last_name",
        "second_last_name",
        "email",
      ]),
    }

    return !isEqual(valueState, valueProps)
  }

  validateButtonPassword = () => {
    const { password, new_password_confirmation, new_password } = this.state
    return password || new_password_confirmation || new_password
  }

  sendPasswordSave = () => {
    const data = {
      new_password: this.state.new_password,
      new_password_confirmation: this.state.new_password_confirmation,
      password: this.state.password,
    }

    this.props.passwordUserWatcher(data)
    this.setState(
      {
        new_password: "",
        new_password_confirmation: "",
        password: "",
      },
      () => {
        this.props.form.resetFields([
          "new_password",
          "new_password_confirmation",
          "password",
        ])
      }
    )
  }

  resetInfo = () => {
    this.setState(this.props.user)

    const onlyUsedProps = pick(this.props.user, [
      "first_name",
      "last_name",
      "second_last_name",
      "email",
    ])
    this.props.form.setFieldsValue(onlyUsedProps)
  }

  updateLanguage = () => {
    const languageFound = this.props.languages.find((language) => {
      return language.locale === this.state.actual_language
    })

    
    if (languageFound) {
      this.props.putLanguageWatcher({
        id_language: languageFound.id_language,
        locale: languageFound.locale,
      })
    }
  }

  resetLanguage = () => {
    this.setState({ actual_language: this.props.user.language })
  }

  handleChangeLanguage = (value) => {
    this.setState({ actual_language: value })
  }

  render() {
    const { loadingPage } = this.state
    const {
      form: { getFieldDecorator },
    } = this.props

    return (
      <Layout>
        <Helmet>
          <title>{this.intlMyAccount.titlePage}</title>
          <meta name="description" content="Description of MyAccount" />
        </Helmet>
        {loadingPage ? (
          <Loader height="80vh" />
        ) : (
          <div className="my-account">
            <div className="my-account__header">{this.intlMyAccount.title}</div>
            <div
              className="my-account__information"
              style={{ paddingBottom: 0 }}>
              {this.validateButtonSave() && (
                <div className="my-account__information-action">
                  <Button onClick={this.resetInfo}>
                    {this.intlMyAccount.btnCancel}
                  </Button>
                  <Button
                    disabled={!validateEmail(this.state.email)}
                    type="primary"
                    onClick={this.sendInfoSave}
                    loading={this.props.isLoadingUser}>
                    {this.intlMyAccount.btnSave}
                  </Button>
                </div>
              )}
              <div
                className="my-account__information-header"
                style={{ marginBottom: 10 }}>
                <div style={{ width: "140px" }}>
                  {this.intlMyAccount.information}
                </div>{" "}
                <Divider />
              </div>
              <div className="my-account__information-email my-account__information-fullname">
                <div>{this.intlMyAccount.nameAndLastName}</div>
                <div style={{ width: 566 }}>
                  <Input.Group compact>
                    <Form.Item style={{ width: "33.3%" }}>
                      {getFieldDecorator("first_name", {
                        initialValue: this.state.first_name,
                        rules: [
                          {
                            required: true,
                            message: formLabelMessage("es", "required"),
                          },
                        ],
                      })(
                        <Input
                          maxLength={80}
                          placeholder={this.intlMyAccount.namePlaceHolder}
                          disabled={!validRole({ role: [1, 2, 3, 4] })}
                          onChange={(e) => {
                            this.setStateFrom("first_name", e.target.value)
                          }}
                        />
                      )}
                    </Form.Item>
                    <Form.Item style={{ width: "33.3%" }}>
                      {getFieldDecorator("last_name", {
                        initialValue: this.state.last_name,
                        rules: [
                          {
                            required: true,
                            message: formLabelMessage("es", "required"),
                          },
                        ],
                      })(
                        <Input
                          maxLength={60}
                          placeholder={this.intlMyAccount.lastNamePlaceHolder}
                          disabled={!validRole({ role: [1, 2, 3, 4] })}
                          onChange={(e) => {
                            this.setStateFrom("last_name", e.target.value)
                          }}
                        />
                      )}
                    </Form.Item>
                    <Form.Item style={{ width: "33.3%" }}>
                      {getFieldDecorator("second_last_name", {
                        initialValue: this.state.second_last_name,
                      })(
                        <Input
                          maxLength={60}
                          placeholder={
                            this.intlMyAccount.secondLastNamePlaceHolder
                          }
                          disabled={!validRole({ role: [1, 2, 3, 4] })}
                          onChange={(e) =>
                            this.setStateFrom(
                              "second_last_name",
                              e.target.value
                            )
                          }
                        />
                      )}
                    </Form.Item>
                  </Input.Group>
                </div>
              </div>
              <div className="my-account__information-email">
                <div>
                  <span>{this.intlMyAccount.email}</span>
                </div>
                <Form.Item style={{ width: 566 }}>
                  {getFieldDecorator("email", {
                    initialValue: this.state.email,
                    rules: [
                      { type: "email", message: formLabel.es.email_valid },
                      {
                        required: true,
                        message: formLabelMessage("es", "required"),
                      },
                    ],
                  })(
                    <Input
                      maxLength={191}
                      disabled={true}
                      placeholder={this.intlMyAccount.emailPlaceHolder}
                      onChange={(e) =>
                        this.setStateFrom("email", e.target.value)
                      }
                    />
                  )}
                </Form.Item>
              </div>
              <div
                className="my-account__information-header"
                style={{ marginBottom: 10 }}>
                <div style={{ width: "140px" }}>
                  {this.intlMyAccount.languageTitle}
                </div>{" "}
                <Divider />
              </div>
              {this.props.actual_language}
              <div
                className="my-account__information-langzone"
                style={{ marginTop: 3 }}>
                <div className="my-account__information-email">
                  <div>{this.intlMyAccount.language}</div>
                  <div style={{ width: 566 }}>
                    <Input.Group compact>
                      <Form.Item style={{ width: "50%" }}>
                        {this.props.languages.length > 0 &&
                          this.props.user &&
                          this.props.user.language && (
                            <Select
                              defaultValue={this.props.user?.language}
                              value={this.state.actual_language}
                              style={{ width: "100%" }}
                              disabled={validRole({ role: [1, 2, 3, 4] })}
                              onChange={this.handleChangeLanguage}>
                              {/*  <Option value="Español">Español</Option> */}
                              {this.props.languages?.map((language) => (
                                <Option
                                  key={`language-${language.id_language}`}
                                  value={language.locale}>
                                  {language.name}
                                </Option>
                              ))}
                            </Select>
                          )}
                      </Form.Item>
                      {this.state.actual_language !=
                        this.props.user?.language && (
                        <Form.Item
                          style={{
                            width: "50%",
                            boxSizing: "border-box",
                            paddingLeft: "10px",
                          }}>
                          <Button onClick={this.resetLanguage}>
                            {this.intlMyAccount.btnCancel}
                          </Button>{" "}
                          &nbsp;&nbsp;
                          <Button type="primary" onClick={this.updateLanguage}>
                            {this.intlMyAccount.btnSave}
                          </Button>
                        </Form.Item>
                      )}
                    </Input.Group>
                  </div>
                </div>
                {/* <div className='my-account__information-email'>
                  <div>Zona horaria</div>
                  <Select defaultValue='1' style={{ width: 320 }}>
                    <Option value='1'>Automática (GMT-05:00)</Option>
                  </Select>
                </div> */}
              </div>
            </div>

            <div className="my-account__information" style={{ paddingTop: 0 }}>
              {this.validateButtonPassword() && (
                <div className="my-account__information-action">
                  <Button
                    // onClick={this.resetInfo}
                    onClick={() => {
                      this.props.form.setFieldsValue({
                        new_password: undefined,
                        password: undefined,
                        new_password_confirmation: undefined,
                      })
                      this.setState({
                        new_password: undefined,
                        password: undefined,
                        new_password_confirmation: undefined,
                      })
                    }}>
                    {this.intlMyAccount.btnCancel}
                  </Button>
                  <Button
                    onClick={this.sendPasswordSave}
                    type="primary"
                    disabled={
                      !this.state.password ||
                      !this.state.new_password_confirmation ||
                      !this.state.new_password
                    }>
                    {this.intlMyAccount.btnSavePassword}
                  </Button>
                </div>
              )}
              <div
                className="my-account__information-header"
                style={{ marginBottom: 10 }}>
                <span
                  style={{
                    display: "inline-block",
                    width: 240,
                    minWidth: 240,
                  }}>
                  {this.intlMyAccount.passwordTitle}
                </span>{" "}
                <Divider />
              </div>
              <div className="my-account__information-email">
                <div>{this.intlMyAccount.currentPassword}</div>
                <Form.Item style={{ width: 566 }}>
                  {getFieldDecorator("password", {
                    initialValue: this.state.password,
                    rules: [
                      {
                        required: true,
                        message: formLabelMessage("es", "required"),
                      },
                    ],
                  })(
                    <Input
                      placeholder={this.intlMyAccount.currentPassword}
                      type="password"
                      maxLength={191}
                      onChange={(e) =>
                        this.setStateFrom("password", e.target.value)
                      }
                    />
                  )}
                </Form.Item>
              </div>
              <div className="my-account__information-email my-account-pass">
                <div>{this.intlMyAccount.newPassword}</div>
                <Form.Item style={{ width: 566 }}>
                  {getFieldDecorator("new_password", {
                    initialValue: this.state.new_password,
                    rules: [
                      {
                        required: true,
                        message: formLabelMessage("es", "required"),
                      },
                    ],
                  })(
                    <Input
                      placeholder={this.intlMyAccount.newPassword}
                      type="password"
                      maxLength={191}
                      onChange={(e) =>
                        this.setStateFrom("new_password", e.target.value)
                      }
                    />
                  )}
                </Form.Item>
              </div>
              <div className="my-account__information-email">
                <div>{this.intlMyAccount.confirmNewPassword}</div>
                <Form.Item style={{ width: 566 }}>
                  {getFieldDecorator("new_password_confirmation", {
                    initialValue: this.state.new_password_confirmation,
                    rules: [
                      {
                        required: true,
                        message: formLabelMessage("es", "required"),
                      },
                    ],
                  })(
                    <Input
                      placeholder={this.intlMyAccount.confirmNewPassword}
                      type="password"
                      maxLength={191}
                      onChange={(e) =>
                        this.setStateFrom(
                          "new_password_confirmation",
                          e.target.value
                        )
                      }
                    />
                  )}
                </Form.Item>
              </div>
            </div>
          </div>
        )}
      </Layout>
    )
  }
}

MyAccount.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  isLoadingUser: makeSelectIsLoadingUser(),
  languages: makeSelectLanguage(),
  isLoadingLanguage: makeSelectIsLoadingLanguage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getUserWatcher: () => dispatch(getUserWatcher()),
    getUserSuccess: () => dispatch(getUserSuccess()),
    putUserWatcher: (params) => dispatch(putUserWatcher(params)),
    passwordUserWatcher: (params) => dispatch(passwordUserWatcher(params)),
    getLanguageWatcher: () => dispatch(getLanguageWatcher()),
    putLanguageWatcher: (params) => dispatch(putLanguageWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "myAccount", reducer })
const withSaga = injectSaga({ key: "myAccount", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(Form.create({ name: "my_account_form" })(MyAccount))
